import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Card, message } from 'antd';

import { mutations } from '../../graphql/graphql';
import { useMutation } from '@apollo/react-hooks';

const Verify = props => {
  const [error, setError] = useState('');
  const { token } = props.match.params;
  const [VERIFY_USER] = useMutation(mutations.VERIFY_USER);

  useEffect(() => {
    VERIFY_USER({ variables: { token } }).then(
      res => {
        message.success('Successfull');
        console.log(res);
      },
      err => {
        try {
          console.log(err.graphQLErrors[0].message);
          setError(err.graphQLErrors[0].extensions.code);
        } catch (error) {
          setError('Error.');
        }
      }
    );
  }, [token]);

  if (!token) {
    return (
      <Card hoverable style={{ minWidth: '350px', width: '50vw' }}>
        <Card.Meta title="Oops..." description="Error." />
      </Card>
    );
  }

  return (
    <Card hoverable style={{ minWidth: '350px', width: '50vw' }}>
      <Card.Meta title="Verify" description={error || 'You have verified your mail, now login'} />
    </Card>
  );
};

Verify.propTypes = {
  token: PropTypes.string
};

export default Verify;
